import React, { useMemo, useState } from 'react';
import _ from 'lodash';
import { Table, Button, Icon, Tooltip, Modal } from 'antd';
import { useGetEnochReportHistory } from '../../../../query/enoch';
import { useEnochFilterContext } from '../context';
import moment from 'moment';
import ReportDetailModal from './ReportDetailModal';

const { Column } = Table;

export default function RunHistory() {
  const filter = useEnochFilterContext();
  const {
    isFetching,
    data,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
  } = useGetEnochReportHistory(filter);
  const renderData = useMemo(() => {
    let result = [];
    if (data) {
      result = _.flatten(data.pages.map(({ data: reports }) => reports));
    }
    return result;
  }, [data]);

  return (
    <Table
      dataSource={renderData}
      footer={() => {
        if (!hasNextPage) return null;
        return (
          <div className="flex" style={{ justifyContent: 'center' }}>
            <Button
              loading={isFetchingNextPage}
              onClick={() => fetchNextPage()}
            >
              {isFetchingNextPage ? 'Loading More...' : 'More Items'}
            </Button>
          </div>
        );
      }}
      loading={isFetching && !isFetchingNextPage}
      pagination={false}
      scroll={{ x: true }}
      size="small"
    >
      <Column
        dataIndex="createdAt"
        fixed="left"
        key="createdAt"
        render={(text, record) => {
          return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <OpenReportDetailButton report={record} />
              <p style={{ marginBottom: 0, marginLeft: 5 }}>
                {moment(text).format('YYYY-MM-DD HH:mm:ss')}
              </p>
            </div>
          );
        }}
        title="Timestamp"
      />
      <Column dataIndex="ipAddress" key="ipAddress" title="IP Address" />
      <Column dataIndex="email" key="email" title="Email" />
      <Column
        align="center"
        key="inboxes"
        render={(text, record) => {
          return `${record.numOfInboxesReplied} / ${record.numOfInboxes}`;
        }}
        title="Inboxes Replied / Total"
      />
      <Column
        align="center"
        key="spams"
        render={(text, record) => {
          return `${record.numOfSpamsMoved} / ${record.numOfSpams}`;
        }}
        title="Spams Moved / Total"
      />
      <Column
        align="center"
        key="promotions"
        render={(text, record) => {
          return `${record.numOfPromotionsMoved} / ${record.numOfPromotions}`;
        }}
        title="Promotions Moved / Total"
      />
      <Column
        align="center"
        key="unimportant"
        render={(text, record) => {
          return `${record.numOfUnimportantMoved} / ${record.numOfUnimportant}`;
        }}
        title="Unimportant Marked / Total"
      />
      <Column
        key="durationInSeconds"
        render={(text, record) => {
          if (!record.durationInSeconds) return null;
          const duration = moment.duration(record.durationInSeconds, 'seconds');
          return moment.utc(duration.as('milliseconds')).format('HH:mm:ss');
        }}
        title="Duration"
      />
    </Table>
  );
}

function OpenReportDetailButton({ report }) {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <Tooltip title="View logs">
        <Icon
          style={{ color: '#337ab7', cursor: 'pointer' }}
          type="code"
          onClick={() => setVisible(true)}
        />
      </Tooltip>
      <Modal
        title={`Enoch Logs`}
        visible={visible}
        width={900}
        onCancel={() => setVisible(false)}
      >
        <ReportDetailModal report={report} />
      </Modal>
    </>
  );
}
